import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useContext, useRef, useState } from "react";
import styled from "styled-components";
import { AbsoluteValue, AutocompleteInput, AutocompleteValue, } from "../../styledSelect/components/DisplayAutocomplete";
import { cssBody400 } from "../../typography/styles";
import { SelectOption } from "../components/SelectOption";
import { Placeholder } from "../components/Styled";
import { USelectContext } from "../context/context";
import { useAutoFocusInput } from "../hooks/useAutoFocusInput";
import { UltraSelectSingle } from "../SingleUltraSelect";
const renderValue = (props) => props.autocomplete ? _jsx(SingleAutocompleteValue, { ...props }) : _jsx(SingleValue, { ...props });
const renderOption = (props) => (_jsx(SelectOption, { ...props }));
export const BaseSingleSelect = (props) => _jsx(UltraSelectSingle, { renderValue: renderValue, renderOption: renderOption, ...props });
const SingleValue = memo(({ value, placeholder, error }) => {
    const selected = value?.[0];
    return (_jsx(Flex, { children: selected ? (_jsx(Value, { children: _jsx("span", { children: selected.label }) })) : (_jsx(Placeholder, { "$error": error, children: placeholder })) }));
});
const SingleAutocompleteValue = memo(({ value, placeholder, error, autocomplete, }) => {
    const selected = value?.[0];
    const inputRef = useRef(null);
    const { search, setSearch } = useContext(USelectContext);
    useAutoFocusInput(inputRef);
    const [focused, setFocused] = useState(false);
    const computedAutocomplete = typeof autocomplete === "boolean" ? "_" : autocomplete;
    return (_jsxs(Flex, { children: [_jsx(AutocompleteInput, { onFocus: () => setFocused(true), onBlur: () => setFocused(false), ref: inputRef, value: search, onChange: (e) => setSearch?.(e.target.value), autoComplete: computedAutocomplete }), !search ? (selected ? (_jsx(AutocompleteValue, { "$hide": focused, "data-hide": focused, children: selected.label })) : (_jsx(AbsolutePlaceholder, { "$error": error, children: placeholder }))) : null] }));
});
const AbsolutePlaceholder = styled(Placeholder) `
  ${AbsoluteValue};
`;
const Value = styled.div `
  ${cssBody400};
  display: flex;
  align-items: center;
`;
const Flex = styled.div `
  display: flex;
  align-items: center;
`;
